
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { useReportTemplateDetail } from '../../../hooks/queries/reportQueries';

const ReportRequestItem = ({ report, onDelete, onPreview }) => {
  const navigate = useNavigate();
  const reportTemplateDetail = useReportTemplateDetail(report?.SelectedReportTemplateSysId);
  const getStatusColor = (status) => {
    switch (status.toLowerCase().trim()) {
      case 'completed': return 'success';
      case 'failed': return 'error';
      case 'pending': return 'warning';
      default: return 'unknown';
    }
  };
  const getStatusText = (status) => {
    switch (status.toLowerCase().trim()) {
      case 'completed': return '완료';
      case 'failed': return '실패';
      case 'pending': return '작업중';
      default: return '알 수 없음';
    }
  };
  return (
    <tr key={report.ReportRequestSysId}>
      <td className="report-name">{report?.ReportTitle || '-'}</td>
      <td className="report-type">{report?.RequestedAt ? dayjs(report.RequestedAt).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
      <td className="report-date">{report?.CompletedAt ? dayjs(report.CompletedAt).format('YYYY-MM-DD HH:mm:ss') : '-'}</td>
      <td className="report-template">{reportTemplateDetail?.data?.TemplateName + ' (' + reportTemplateDetail?.data?.Version + ')' || '-'}</td>
      <td className="report-status">
        <span className={`status-badge ${getStatusColor(report?.Status)}`}>
          {getStatusText(report?.Status)}
        </span>
      </td>
      <td>
        <div className="flex gap-5 justify-end">
          {report?.Status?.toLowerCase().trim() === 'completed' && (
            <button 
              className="btn btn-style-5 small-btn" 
              onClick={() => navigate(`/report-request-management/preview/${report.ReportRequestSysId}`)}
            >
              미리보기
            </button>
          )}
          <button className="btn btn-style-5 small-btn" onClick={() => onDelete({...report, templateName: reportTemplateDetail?.data?.TemplateName})}>삭제</button>
        </div>
      </td>
    </tr>
  )
}

export default ReportRequestItem